import React from 'react';

export default function LegalNoticePage() {
  return (
    <div className="max-w-4xl mx-auto p-8 text-gray-800 leading-7">
      <h1 className="text-3xl font-bold mb-6">Aviso legal</h1>

      <p className="mb-4">
        En cumplimiento del artículo 10 de la Ley 34/2002, de servicios de la sociedad de la información y de comercio electrónico, se informa de los siguientes datos identificativos del titular del sitio web:
      </p>

      <ul className="list-disc pl-5 mb-4 space-y-1">
        <li><strong>Titular:</strong> 77 SUAN XI S.L.</li>
        <li><strong>CIF:</strong> B-13924379</li>
        <li><strong>Domicilio:</strong> Calle Anatolio de Fuentes García 2, Polígono Costa Sur</li>
        <li><strong>Correo electrónico de contacto:</strong> informundolandia@gmail.com</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Objeto</h2>
      <p className="mb-4">
        Este sitio web tiene carácter informativo y facilita contenidos, formularios de contacto o registro y, en su caso, acceso a funcionalidades relacionadas con la actividad del parque, la gestión de bonos y la organización de visitas.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Condiciones de uso del sitio</h2>
      <p className="mb-4">
        La persona usuaria se compromete a utilizar el sitio web de conformidad con la ley, la buena fe, el orden público y el presente aviso legal. Queda prohibido realizar actuaciones que puedan dañar, inutilizar, sobrecargar o deteriorar el sitio o impedir su normal utilización.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Propiedad intelectual e industrial</h2>
      <p className="mb-4">
        Los contenidos, textos, diseños, imágenes, marcas, logotipos y demás elementos del sitio están protegidos por la normativa aplicable en materia de propiedad intelectual e industrial y pertenecen al titular o a terceros con autorización. No se autoriza su reproducción, distribución o transformación sin permiso previo, salvo los usos legalmente permitidos.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Responsabilidad</h2>
      <p className="mb-4">
        El titular adopta medidas razonables para que la información del sitio sea correcta y esté actualizada, pero no garantiza la inexistencia de errores, interrupciones o incidencias técnicas. Tampoco se hace responsable del uso indebido que las personas usuarias puedan realizar del contenido o de enlaces externos.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Legislación y jurisdicción</h2>
      <p className="mb-4">
        La relación con las personas usuarias se regirá por la legislación española. En caso de conflicto, y salvo que una norma imperativa disponga otra cosa, las partes se someterán a los juzgados y tribunales que resulten competentes conforme a Derecho.
      </p>
    </div>
  );
}
